<!--
  Menu Slide Transition

  @since 2018-02-23
  @author kdydesign.kim
-->

<template>
  <transition name="expand-menu" @after-enter="afterTransition" @after-leave="afterTransition">
    <slot></slot>
  </transition>
</template>

<script>
  export default {
    name: 'MenuSlideTransition',
    methods: {
      afterTransition () {
        this.$emit('afterTransition')
      }
    }
  }
</script>

<style scoped>
  .expand-menu-enter-active, .expand-menu-leave-active {
    transition: all .5s ease-in-out;
    max-width: 360px;
  }

  .expand-menu-enter, .expand-menu-leave-to {
    max-width: 0;
  }
</style>
